<template>

  <v-stepper
    class="dehn-v-stepper"
    :alt-labels="this.$vuetify.breakpoint.mdAndUp"
    v-model="roiCurrentStep"
  >
    <v-stepper-header
      @mouseenter="editIcon = '$edit'"
      @mouseleave="editIcon = '$complete'"
    >
      <template v-for="n in steps">
        <v-stepper-step
          :key="`${n}-step`"
          :complete="roiCurrentStep > n"
          :step="n"
          :edit-icon="editIcon"
        >
          {{ roiSuperGroups[n - 1]['name']}}
        </v-stepper-step>
        <v-divider
          v-if="n !== steps"
          :key="n"
        ></v-divider>
      </template>
      <v-divider></v-divider>
      <v-stepper-step
        :step="5"
      >
        {{ $t("result.stepperTitle") }}
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        v-for="n in steps"
        :key="`${n}-content`"
        :step="n"
      >
        <v-card flat class="roi-card-transparent">
          <v-container fluid>
            <v-row>
              <step
                :current-step="n"
                :current-roi-group="roiSuperGroups[n - 1]['id']"
                :validate-me="validationFired['step' + n]"
              ></step>
            </v-row>
          </v-container>
        </v-card>

        <step-footer-navigation
          :current-step="n"
          :last-step="maxSteps"
          v-on:update:nextStep="nextStep($event)"
        ></step-footer-navigation>

      </v-stepper-content>
      <v-stepper-content step="5">
        <step-result></step-result>
        <step-footer-navigation
          :current-step="5"
          :last-step="maxSteps"
          v-on:update:nextStep="nextStep($event)"
        ></step-footer-navigation>
      </v-stepper-content>
    </v-stepper-items>


  </v-stepper>

</template>

<script>
import {mapGetters, mapState} from "vuex";
import Step from "./Step";
import StepResult from "./StepResult";
import StepFooterNavigation from "./StepFooterNavigation";


export default {
  name: "Stepper",
  components: {Step, StepResult, StepFooterNavigation},
  data () {
    return {
      maxSteps: 5,
      editIcon: '$complete',
      validationFired: {
        step1: '',
        step2: '',
        step3: '',
        step4: '',
        step5: '',
      },
    }
  },

  watch: {
    steps (val) {
      if (this.roiCurrentStep > val) {
        this.$store.commit('SET_ROI_CURRENT_STEP', val)
      }
    },
  },

  created() {
    this.validateAll(true);
  },

  computed: {
    isEditableStep: function() {
      let isEditable = {
        step1: true,
        step2: this.$store.state.roiStepsValid['R_GROUP_0001'].valid,
        step3: this.$store.state.roiStepsValid['R_GROUP_0001'].valid && this.$store.state.roiStepsValid['R_GROUP_0002'].valid,
        step4: this.$store.state.roiStepsValid['R_GROUP_0001'].valid && this.$store.state.roiStepsValid['R_GROUP_0002'].valid
          && this.$store.state.roiStepsValid['R_GROUP_0003'].valid,
        step5: this.$store.state.roiStepsValid['R_GROUP_0001'].valid && this.$store.state.roiStepsValid['R_GROUP_0002'].valid
          && this.$store.state.roiStepsValid['R_GROUP_0003'].valid && this.$store.state.roiStepsValid['R_GROUP_0004'].valid,
      };
      return isEditable;
    },
    roiCurrentStep: {
      get () {
        return this.$store.state.roiCurrentStep
      },
      set (value) {
        this.$store.commit('SET_ROI_CURRENT_STEP', value)
      }
    },
    ...mapGetters([
      'roiSuperGroups',
      'errors',
      // ...
    ]),
    ...mapState({
      roiStepsValid: state => state.roiStepsValid,
    }),
    steps: function() {
      return this.$store.state.roiSuperGroups.length
    },
  },

  methods: {
    validateAll(initial=false) {

      //console.log('running validation');

      if (!initial) {
        this.validationFired['step'+this.roiCurrentStep] = this.roiCurrentStep + Date.now();
      }

    },
    nextStep (toStep) {

      if (toStep > this.roiCurrentStep) {
        this.validateAll();
        if (this.$store.state.roiStepsValid['R_GROUP_000' + this.roiCurrentStep].valid) {
          this.$store.commit('SET_ROI_CURRENT_STEP', toStep)
        }
      } else {
        this.$store.commit('SET_ROI_CURRENT_STEP', toStep)
      }

    },
  },
}
</script>

<style lang="scss" scoped>

.step-optional {
  opacity: 0.3;
}

</style>
